import { useTranslation } from "react-i18next";

/**
 * Custom hook to localize multiple datasets with their corresponding namespaces.
 *
 * @param {Object} dataWithNamespaces - An object where the keys are namespaces and the values are datasets.
 * @returns {Object} localizedData - An object where each key is a namespace and each value is the localized dataset.
 */
const useLocalizedData = (dataWithNamespaces) => {
  const { t } = useTranslation(); // Translation function

  // Iterate over each dataset and its corresponding namespace, and localize them
  const localizedData = Object.keys(dataWithNamespaces).reduce((acc, namespace) => {
    const data = dataWithNamespaces[namespace];
    console.log("namespace", namespace, data, dataWithNamespaces);

    // Map through the dataset and apply localization to the 'label' field
    acc[namespace] = data.map((item) => ({
      ...item, // Spread the existing fields
      text: t(`${namespace}_${item.text}`), // Translate the 'label' field using the namespace
    }));

    return acc;
  }, {});

  return localizedData;
};

export default useLocalizedData;
